/**
 * @description YouTube設定
 */
let youtubeIframes = [];
window.addEventListener('DOMContentLoaded', function() {
  youtubeIframes = document.getElementsByClassName('c-video__youtube');
  if (youtubeIframes.length) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}, false);

function onYouTubeIframeAPIReady() {
  const players = [];
  for (let i = 0; i < youtubeIframes.length; i++) {
console.log('id = ' + youtubeIframes[i].id);
    document.getElementById(youtubeIframes[i].id).style.backgroundImage = `url("https://i.ytimg.com/vi/${youtubeIframes[i].id}/hqdefault.jpg")`;
    document.getElementById(youtubeIframes[i].id).addEventListener('click', function() {
      players[i] = new YT.Player(youtubeIframes[i].id, {
        width: '560',
        height: '315',
        videoId: youtubeIframes[i].id,
        playerVars: {
          rel: 0.
        },
        events: {
          'onReady': onPlayerReady,
          // 'onError': onPlayerError,
        }
      });
    });
  }
}

function onPlayerReady(event) {
  // 動画までスクロールしたら自動再生
  // switchVideo(event.target);
  // window.addEventListener('scroll', function() {
  //   switchVideo(event.target);
  // }, false);

  event.target.playVideo();
}

// HTML5プレーヤーでエラーが発生した時に呼び出される関数（Flashプレーヤーの場合は何もかえらない）
//   2: 無効なパラメータが含まれている（動画IDが間違っている場合など）
//   5: 再生不可
// 100: 動画が未取得（動画が削除されている、プライベート動画など）
// 101: 所有者により埋め込みが禁止されている動画
// 150: 101と同じ
// function onPlayerError(event) {
//   if (event.data == 100) {
//     alert('動画がありません');
//   }
// }

// function switchVideo(targetPlayer) {
//   const playerPosition = targetPlayer.getIframe().getBoundingClientRect().top + window.pageYOffset;
//   const startPosition = window.pageYOffset + window.innerHeight;
//   const endPosition = window.pageYOffset;
//   if((playerPosition < startPosition) && (playerPosition > endPosition)) {
//     // if(targetPlayer.getPlayerState() == "-1") {
//     //   targetPlayer.mute();
//     // }
//     targetPlayer.mute();
//     targetPlayer.playVideo();
//   }
//   else {
//     targetPlayer.pauseVideo();
//   }
// }

(() => {
  /**
   * @description Swiper設定
   */
  let swiper = new Swiper('.swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    breakpoints: {
      0: {
        slidesPerView: 1.3,
      },
      1023: {
        slidesPerView: 4,
      }
    },
    loop: true,
    // autoplay: {
    //   delay: 3000,
    //   pauseOnMouseEnter: true,
    //   disableOnInteraction: false,
    // },
    speed: 1500,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  /**
   * @description カテゴリータグの追加
   */
  // 中学
  const chugakuEl = document.querySelectorAll('.jyukenportal__chugaku .jyukenportal__info');
  chugakuEl.forEach((element, index) => {
    const aEl = document.createElement('a');
    aEl.textContent = '中学';
    aEl.href = '/wadai/kyoiku/Junior_high_school_exa';
    aEl.className = 'jyukenportal__skyblue';
    element.prepend(aEl);
  });

  // 高校
  const koukouEl = document.querySelectorAll('.jyukenportal__koukou .jyukenportal__info');
  koukouEl.forEach((element, index) => {
    const aEl = document.createElement('a');
    aEl.textContent = '高校';
    aEl.href = '/wadai/kyoiku/high_school_exa';
    aEl.className = 'jyukenportal__purple';
    element.prepend(aEl);
  });

  // 大学
  const daigakuEl = document.querySelectorAll('.jyukenportal__daigaku .jyukenportal__info');
  daigakuEl.forEach((element, index) => {
    const aEl = document.createElement('a');
    aEl.textContent = '大学';
    aEl.href = '/wadai/kyoiku/university_exa';
    aEl.className = 'jyukenportal__winered';
    element.prepend(aEl);
  });

  // 総合
  const movieEl = document.querySelectorAll('.jyukenportal__movie .jyukenportal__info');
  movieEl.forEach((element, index) => {
    const aEl = document.createElement('a');
    aEl.textContent = '動画';
    aEl.href = '/wadai/kyoiku/edu_movie';
    aEl.className = 'jyukenportal__orange';
    element.prepend(aEl);
  });
})();